<template>
  <div class="study-engagement-contents">
    <div>
      <b-row>
        <b-colxx xxs="12">
          <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>
      <!-- Study dropdown groups -->
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0">
          <header-drop-down-filter
            :leftHeaderText="leftHeaderTextValue"
            :sites="allSitesList"
            :countries="countryList"
            :callApiCompleted="callApiCompleted"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
            :exportBtn="true"
            :participantsBtn="true"
            @onApplyCountry="onFilterCountry"
            @onApplySites="onFilterSites"
            @onApplyParticipants="onFilterParticipants"
            @onFetchedParticipants="fetchedParticipants"
            @onApplyFpi="filter"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"
            v-if="studyData"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            :toggleFeatures="toggleFeatures"
            :studyData="studyData"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>
      <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        Back
      </div>

      <!-- Average Duration by Device -->
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'average-duration-by-device'">
        <b-colxx class="pl-0 pb-6" xl="12" lg="12" md="12" :class="zoomGraphValue === 'average-duration-by-device' ? 'average-duration-by-device-zoom' : ''" style="transition-duration: 0.2s">
          <AverageDurationByDevice
            :engagementRaw="rawData"
            :filterTriggered="filterTriggered"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            :dataLoaded="dataLoaded.rawData"
            v-on:zoomEnabled="zoomGraphValue = 'average-duration-by-device'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            titleChart="Average Duration by Device"
          >
          </AverageDurationByDevice>
        </b-colxx>
      </b-row>
      <!-- End Average Duration by Device -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import _get from "lodash/get";
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import { AclRule } from "vue-acl";
import HeaderDropDownFilter from "../form-components/header-drop-down-filter";
import Loading from "vue-loading-overlay";
import AverageDurationByDevice from "../containers/average-duration-by-device";
import * as utils from "../../services/visualization/utils";

import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading);

const convertArrToString = arrObj => {
  let resultString = ``;
  if (arrObj && arrObj.length > 0) {
    arrObj.forEach(o => {
      resultString += `${o},`;
    });
    resultString = resultString.slice(0, -1);
  }
  return resultString;
};

export default {
  components: {
    HeaderDropDownFilter,
    AverageDurationByDevice
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    complianceWidgets: { type: Boolean, default: false },
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      rawData: {},
      firstFromDate: null,
      firstToDate: null,
      filterTriggered: false,
      siteListInParticipants: [],
      studyId: null,
      countryList: [],
      allSitesList: [],
      callApiCompleted: null,
      sitesSelected: ["all"],
      participantsSelected: ["all"],
      countrySelected: "all",
      studySelected: null,
      studyList: null,
      leftHeaderTextValue: "Engagement Dashboard",
      monthSelected: [],
      // fromDate and toDate is a string value for date filter. Format would be YYYY-MM-DD
      fromDate: null,
      toDate: null,
      tabIndexOverallCollectionMetric: 0,
      dataPicker: [],
      todaysDate: "",
      tabOverallMissing: 0,
      zoomGraphValue: "",
      // you will get specific ID if you're not SystemAdmin
      specificSiteId: null,
      loader: null,
      isLoading: true,
      dataLoaded: {},
      tmpCountries: [],
      tmpSites: []
    };
  },
  methods: {
    async getEngagementData() {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };

      if (this.fromDate) {
        params.fromDate = this.fromDate;
        params.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        params.participantsIds = convertArrToString(this.participantsSelected);
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        params.siteId = this.specificSiteId[0];
      }

      const data = await this.$api.getStudyEngagementData(params);

      if (data.ok) {
        const result = data.body;

        if (result.data !== {}) {
          response = result.data;
        }
      }
      this.isLoading = false;
      return response;
    },

    // This required function in every feature
    onFilterCountry(payload) {
      this.filter("country", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },

    // This required function in every feature
    onFilterSites(payload) {
      this.filter("site", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },

    // This required function in every feature
    onFilterParticipants(payload) {
      this.filter("participant", payload.isCheckAll ? "all" : payload);
    },

    // This required function in every feature
    getRangeMonth(payload) {
      this.filter("date", payload);
    },

    // This required function in every feature
    async filter(triggerBy, filterValue) {
      switch (triggerBy) {
        case "country": {
          this.countrySelected = filterValue;
          const payload = {
            countries: {
              ...this.rawData
            }
          };

          const countrySelected = filterValue === "all" ? this.countryList : filterValue;
          this.allSitesList = utils.getAllSitesWhenFilteringCountry(payload, countrySelected);
          this.sitesSelected = filterValue === "all" ? ["all"] : this.allSitesList;
          break;
        }
        case "site": {
          this.sitesSelected = filterValue === "all" ? ["all"] : filterValue;
          break;
        }
        case "date": {
          this.monthSelected = filterValue;

          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;

          if (this.fromDate === this.firstFromDate && this.toDate === this.firstToDate) {
            this.fromDate = null;
            this.toDate = null; // Reset date to default value
          }
          break;
        }
        case "participant": {
          this.participantsSelected = filterValue === "all" ? ["all"] : filterValue.checkedParticipants;
          if (this.participantsSelected && this.participantsSelected.length === 0) {
            this.setToEmptyData();
            return;
          }
          break;
        }
        default:
          break;
      }
      this.callApi(true, triggerBy);
      this.filterTriggered = !this.filterTriggered;
    },

    // This required function in every feature
    setToEmptyData() {
      this.rawData = null;
    },
    async callApi(turnOffGlobalLoader = false, filterBy) {
      let apiPromises = [];
      let newCountries = [];
      let newSites = [];

      if (["mounted", "date"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          this.getEngagementData().then(raws => {
            const countries = utils.getCountries(raws);
            const sites = utils.getSites(raws, countries);

            this.tmpCountries = this.tmpCountries.concat(countries);
            this.tmpSites = this.tmpSites.concat(sites);
            this.rawData = raws;
            this.dataLoaded.rawData = true;
          })
        ]);
      }

      if (["participant"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          this.getEngagementData().then(raws => {
            const countries = utils.getCountries(raws);
            const sites = utils.getSites(raws, countries);

            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.rawData = raws;
            this.dataLoaded.rawData = true;
          })
        ]);
      }
      await Promise.all(apiPromises);
      if (["participant"].includes(filterBy)) {
        this.tmpCountries = newCountries;
        this.tmpSites = newSites;
      }
      this.callApiCompleted = true;
      if (turnOffGlobalLoader) {
        await this.turnOffGlobalLoader();
      }
    },
    // This required function in every feature
    async prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      const tmpPicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
        tmpPicker.push(m.format("YYYY-MM-DD"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];
      this.monthSelected = [firstMonth, lastMonth];
    },
    fetchedParticipants(payload) {
      this.siteListInParticipants = payload;
    },

    async turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
    }
  },
  watch: {
    tmpCountries: function(val) {
      const allCountries = _.uniq(val);
      this.countryList = _.orderBy(Array.from(allCountries), [country => country.toLowerCase()]);
    },

    tmpSites: function(val) {
      const allSites = _.uniq(val);
      this.allSitesList = _.orderBy(Array.from(allSites), [site => site.toLowerCase()]);
    }
  },

  computed: {
    ...mapGetters(["user"]),
    userAccess() {
      return new AclRule(this.user.userRole).generate();
    }
  },

  async mounted() {
    this.$router.push({ query: { automatic_off_loader: false } });
    this.studyId = this.$route.params.studyId;
    await this.prepareDatePicker();

    this.specificSiteId = _get(this.user, "siteIds", []);
    this.callApi(true, "mounted");
  }
};
</script>
